import { render, staticRenderFns } from "./UnsupportedBrowserScreen.vue?vue&type=template&id=56a01c39&scoped=true&"
import script from "./UnsupportedBrowserScreen.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBrowserScreen.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedBrowserScreen.vue?vue&type=style&index=0&id=56a01c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a01c39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a01c39')) {
      api.createRecord('56a01c39', component.options)
    } else {
      api.reload('56a01c39', component.options)
    }
    module.hot.accept("./UnsupportedBrowserScreen.vue?vue&type=template&id=56a01c39&scoped=true&", function () {
      api.rerender('56a01c39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UnsupportedBrowserScreen.vue"
export default component.exports